module.exports = __webpack_public_path__ + "static/PromoUpd-d778b3bf9fb1f6d57dee9cbbe04bca40.mp4";